import { useAppStore } from '@store'
import { LightType } from '@types'
import { SCENE_ENVIRONMENT_INTENSITY } from '@constants'
import { Environment } from '@react-three/drei'
import { useMemo } from 'react'
import isLight from '@utils/sceneObjects/assertions/isLight'
import { AmbientLight3D } from './Light/AmbientLight3D'
import { DirectionalLight3D } from './Light/DirectionalLight3D'
import { PointLight3D } from './Light/PointLight3D'
import { SpotLight3D } from './Light/SpotLight3D'
export function LightsManager3D() {
  const performanceMode = useAppStore((s) => s.performanceMode)
  // Obtener todas las luces de la store, no solo las de la capa actual
  const items = useAppStore.use.items()
  const lights = useMemo(() => {
    return Array.from(items.values()).filter((item): item is LightType => {
      return isLight(item)
    })
  }, [items])

  return (
    <group>
      {!performanceMode && (
        <Environment
          preset='studio'
          environmentIntensity={SCENE_ENVIRONMENT_INTENSITY}
        />
      )}
      <AmbientLight3D key='ambient-light-3d' />
      {lights.map((obj) => {
        if (!obj) return null

        switch (obj.lightType) {
          case 'directionallight':
            return (
              <DirectionalLight3D
                key={`${obj.name}-${obj.id}`}
                {...obj}
              />
            )
          case 'spotlight':
            return (
              <SpotLight3D
                key={`${obj.name}-${obj.id}`}
                {...obj}
              />
            )
          case 'pointlight':
            return (
              <PointLight3D
                key={`${obj.name}-${obj.id}`}
                {...obj}
              />
            )
          case 'ambientlight':
            return (
              <AmbientLight3D
                key={obj.id}
                {...obj}
              />
            )
        }
      })}
    </group>
  )
}
